import React, { useEffect, useState, useRef } from "react";
import NewsFeed from "./NewsFeed";
import "../assets/css/ChatBot.css";
import badIcon from "../assets/images/icons/bad-icon.svg";
import areaIcon from "../assets/images/icons/area-icon.svg";
import badminton from "../assets/images/icons/badminton.svg";
import bathtub from "../assets/images/icons/bathtub-icon.svg";
import gymnasium from "../assets/images/icons/gymnasium.svg";
import swimming from "../assets/images/icons/swimming-pool.svg";

const SESSION_ID_KEY = "estchat_session_id";

function getSession() {
  let id = localStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = "sess_" + Math.random().toString(36).substring(2);
    localStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
}

function formatPrice(amount) {
  if (!amount || Number(amount) === 0) return "On Request";

  const num = Number(amount);

  if (num >= 10000000) {
    return (num / 10000000).toFixed(2) + " Cr";
  }
  if (num >= 100000) {
    return (num / 100000).toFixed(2) + " Lacs";
  }
  return num.toLocaleString("en-IN");
}


function ChatBot() {

  const [hasUserReplied, setHasUserReplied] = useState(false);
  const [allProperties, setAllProperties] = useState({});
  const [propertyIndex, setPropertyIndex] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState(null);
  const [showTerms, setShowTerms] = useState(false);
  const [enquiryErrors, setEnquiryErrors] = useState({});


  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [enquiryData, setEnquiryData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [showFeedback, setShowFeedback] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({});
  const [feedbackSuccess, setFeedbackSuccess] = useState(false);

  const [showNews, setShowNews] = useState(false);
  
  // 🔒 Hide header & footer when enquiry modal is open (mobile fix)
  useEffect(() => {
    if (showEnquiry) {
      document.body.classList.add("enquiry-open");
    } else {
      document.body.classList.remove("enquiry-open");
    }
  }, [showEnquiry]);


  const handleSubmitFeedback = async () => {
  const newErrors = {};

  // Validation
  if (!mobile.trim()) {
    newErrors.mobile = "Mobile number is required";
  } else if (!/^[6-9]\d{9}$/.test(mobile)) {
    newErrors.mobile = "Enter a valid 10-digit mobile number";
  }

  if (!feedback.trim()) {
    newErrors.feedback = "Feedback cannot be empty";
  }

  setErrors(newErrors);

  // Stop if validation fails
  if (Object.keys(newErrors).length > 0) return;

  try {
    // API call
    // const response = await fetch("http://127.0.0.1:5001/api/submit_feedback", {
    // const response = await fetch("https://api.estchat.com/api/submit_feedback", {
    const response = await fetch("https://api.aocrpl.chat/api/submit_feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mobile,
        feedback,
        session_id: getSession(),
      }),
    });

    const data = await response.json();

    if (data.status === "success") {
      // Show success popup
      setFeedbackSuccess(true);

      // Close modal
      setShowFeedback(false);

      // Reset form
      setMobile("");
      setFeedback("");
      setErrors({});

      // Auto-close popup after 2.5s
      setTimeout(() => setFeedbackSuccess(false), 2500);
    } else {
      alert(data.message || "Error submitting feedback");
    }
  } catch (err) {
    console.error("Feedback API Error:", err);
    alert("Something went wrong, try again later!");
  }
};





  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: `<div class="intro-message">
              <h2>Good Day! 👋</h2>
              <p>I’m here to make your property search easy, smart, and stress-free.<br/>
              What would you like to search today?</p>
            </div>`,
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  // Auto scroll to bottom
  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Helper to group properties in rows
  const groupIntoRows = (items, size = 3) =>
    Array.from({ length: Math.ceil(items.length / size) }, (_, i) =>
      items.slice(i * size, i * size + size)
    );

  const detectContactInfo = (text) => {
    const namePattern = /([A-Za-z]{2,})/;
    const emailPattern = /[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/;
    const phonePattern = /\b\d{10}\b/;
    const name = text.match(namePattern)?.[1] || "";
    const email = text.match(emailPattern)?.[0] || "";
    const phone = text.match(phonePattern)?.[0] || "";
    return name && email && phone ? { name, email, phone } : null;
  };

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    const newMessages = [...messages, userMessage];
    if (!hasUserReplied) setHasUserReplied(true);
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    const contact = detectContactInfo(input);
    if (contact) {
      try {
        await fetch("https://api.aocrpl.chat/api/enquiry", {
        // await fetch("https://api.estchat.com/api/enquiry", {
        // await fetch("http://127.0.0.1:5001/api/enquiry", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...contact,
            history: newMessages,
          }),
        });
      } catch (e) {
        console.error("Error saving contact:", e);
      }
    }

    try {
      //const response = await fetch("https://api.estchat.com/api/chat", {
      // const response = await fetch("https://api.estchat.com/api/parse_query", {
      // const response = await fetch("http://127.0.0.1:5001/api/parse_query", {
      const response = await fetch("https://api.aocrpl.chat/api/parse_query", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: getSession(), message: input }),
      });

      const data = await response.json();
      console.log("🟢 Chat API Response:", data);

      const botMessages = [];
      const suggestions = Array.isArray(data.suggestions)
        ? data.suggestions
        : [];
      const replyText =
        typeof data.reply === "string" ? data.reply : "Sorry, I didn’t get that.";
      const contextId = Date.now().toString();
      const tipsHtml = data.tips;
      const userQueryText = input;

      // ✅ Handle property suggestions
      if (suggestions.length > 0) {
        const grouped = groupIntoRows(suggestions.slice(0, 6));
        setAllProperties((prev) => ({ ...prev, [contextId]: suggestions }));
        setPropertyIndex((prev) => ({ ...prev, [contextId]: 6 }));

        // botMessages.push({
        //   sender: "bot",
        //   text: "Here are the options for 2 BHK Flats in whitfeild , Banghaloem, based on your query ",
        // });
        botMessages.push({
          sender: "bot",
          text: `
            <div class="query-ack">
              <div>You are asking:</div>
              <div><strong>${userQueryText}</strong></div>
              <div>Here's what I found that best matches your requirement 👇</div>
            </div>
          `,
        });


        grouped.forEach((group) => {
          botMessages.push({
            sender: "property-group",
            contextId,
            data: group,
          });
        });

        if (suggestions.length > 6) {
          botMessages.push({
            type: "button",
            label: "Load More Properties",
            contextId,
          });
        }
      }

      // 3️⃣ Tips AFTER properties
      if (suggestions.length > 0 && tipsHtml) {
        botMessages.push({
          sender: "bot",
          text: tipsHtml, // 👈 IMPORTANT
        });
      }

      // ✅ Add main bot reply
      if (replyText) {
        botMessages.push({ sender: "bot", text: replyText });
        //botMessages.push({ sender: "bot", text: `<strong>${replyText}</strong>`, });
      }

      setMessages((prev) => [...newMessages, ...botMessages]);
    } catch (error) {
      console.error("❌ Chat Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = (contextId) => {
    const nextProps = allProperties[contextId] || [];
    const currentIndex = propertyIndex[contextId] || 0;
    const nextBatch = groupIntoRows(
      nextProps.slice(currentIndex, currentIndex + 6)
    ).map((group) => ({
      sender: "property-group",
      contextId,
      data: group,
    }));

    const newIndex = currentIndex + 6;
    const insertAt = messages.findIndex(
      (m) => m.type === "button" && m.contextId === contextId
    );
    const updatedMessages = [...messages];

    updatedMessages.splice(insertAt, 0, ...nextBatch);

    if (newIndex < nextProps.length) {
      updatedMessages[insertAt + nextBatch.length] = {
        type: "button",
        label: "Load More Properties",
        contextId,
      };
    } else {
      updatedMessages.splice(insertAt + nextBatch.length, 1);
    }

    setPropertyIndex((prev) => ({ ...prev, [contextId]: newIndex }));
    setMessages(updatedMessages);
  };

  // 🏠 Fetch Property Details
  const fetchPropertyDetails = async (propertyId) => {
    try {
      const res = await fetch(`https://api.aocrpl.chat/api/property/${propertyId}`);
      // const res = await fetch(`https://api.estchat.com/api/property/${propertyId}`);
      // const res = await fetch(`http://127.0.0.1:5001/api/property/${propertyId}`);
      if (!res.ok) throw new Error("Failed to load property details");
      const data = await res.json();
      setPropertyDetails(data);
      setShowDetails(true);
    } catch (err) {
      console.error("❌ Property Details Fetch Error:", err);
    }
  };

  console.log("Current Messages:", fetchPropertyDetails); 

    const handleSubmitEnquiry = async () => {
      const errors = {};
      if (!enquiryData.name.trim()) errors.name = "Name is required";
      if (!enquiryData.email.trim()) errors.email = "Email is required";
      if (!enquiryData.phone.trim()) errors.phone = "Phone number is required";

      setEnquiryErrors(errors);

      if (Object.keys(errors).length > 0) return;


      try {
        const res = await fetch("https://api.aocrpl.chat/api/enquiry", {
        // const res = await fetch("https://api.estchat.com/api/enquiry", {
        // const res = await fetch("http://127.0.0.1:5001/api/enquiry", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: enquiryData.name,
            email: enquiryData.email,
            phone: enquiryData.phone,
            chat_history: messages,
            property_id: selectedProperty?.property_id || selectedProperty?.id || null,
            city: selectedProperty?.city || null,
            location: selectedProperty?.location || null,
            property_type: selectedProperty?.property_type || null,
            budget: selectedProperty?.amount || null,
          }),
        });

        const data = await res.json();
        if (data.status === "success") {
          setShowEnquiry(false);
          setEnquiryData({ name: "", email: "", phone: "", message: "" });
          setShowSuccessPopup(true);
          setTimeout(() => setShowSuccessPopup(false), 2500); // auto close after 2.5s
        } else {
          alert("❌ " + (data.message || "Failed to send enquiry."));
        }
      } catch (err) {
        console.error("❌ Enquiry Error:", err);
        alert("Error sending enquiry. Try again later.");
      }
    };


  const handleKeyPress = (e) => {
    if (e.key === "Enter") sendMessage();
  };
const [isBotPopupOpen, setIsBotPopupOpen] = useState(false);
const [botPopupData, setBotPopupData] = useState(null);

console.log("Bot Popup Data:", botPopupData);

  return (
    <div className="chat-layout">
      <div className="left-panel">
        <div className="left-header">
          <img
            src="https://www.addressofchoice.com/aoc_assets_new/images/est-chat.svg"
            alt="Logo"
            className="left-logo"
          />
        </div>
        <div className="left-scroll-content">
          {/* <NewsFeed /> */}
          <NewsFeed
            onBannerClick={() => {
              setSelectedProperty({ id: 100, property_name: "Danube Breez - Dubai Maritime City" });
              setShowEnquiry(true);
            }}
          />
        </div>

        <div className="powered-by-left">
          Powered by <img
              src="https://www.addressofchoice.com/aoc_assets_new/images/favicon.png"
              alt="AddressOfChoice"
              height="26"
            />
        </div>
      </div>

      <div className="right-panel">
        <div className="chat-header">
          <div className="chat-title">

            {/* Desktop text */}
            <h1 className="title-text">Real Estate Assistant </h1>

            {/* Mobile logo */}
            <img
              src="https://www.addressofchoice.com/aoc_assets_new/images/est-chat.svg"
              alt="estChat"
              className="title-logo"
            />

          </div>

          <div className="chat-header-right">
            <span className="support-phone">📞 +91-8800117588</span>
          </div>
        </div>


        <div className="chat-container">
          <div
            className={`chat-box ${
              messages.length === 1 ? "centered-first" : ""
            }`}
          >
            {messages.map((msg, i) => {
              if (msg.sender === "property-group") {
  return (
    <div key={i} className="bot-prop-wrap">
      {msg.data.map((property, index) => (
        <div key={index} className="bot-property-wrapper">

          {/* Each Property = Separate Card */}
          <div className="bot-property-box">

            <div className="bot-left">
              {/* <h3 className="bot-prop-title">{property.property_name}</h3> */}
                <div className="bot-prop-title-wrapper">
                    <h3 className="bot-prop-title">
                      {property.property_type} Flat In {property.property_name}
                    </h3>

                    {/* Hover Image Preview */}
                    <div className="prop-hover-image">
                      <img 
                        src={property.image_url || property.cover_image || "https://via.placeholder.com/300x200?text=No+Image"} 
                        alt={property.property_name} 
                      />
                    </div>
                  </div>


              <div className="bot-prop-meta">
                <span>📍 {property.location}, <b>{property.city}</b></span>
                <span className="bot-sep">|</span>
                {/* <span>🛏 {property.property_type} </span>
                <span className="bot-sep">|</span>
                <span>🛁 {String(property.bathroom || "NA").replace(/T$/i, "")} Baths</span>
                <span className="bot-sep">|</span> */}
                <span>📐 {property.unit_size || "NA"}</span>
                <span className="bot-sep">|</span>

                <span className="bot-inline-price">
                  ₹ {formatPrice(property.amount)}
                </span>
                <div className="bot-right">
                    <button
                      className="bot-enquiry-btn"
                      onClick={() => {
                        setSelectedProperty(property);
                        setShowEnquiry(true);
                      }}
                    >
                      Enquire Now
                    </button>
                  </div>
              </div>

             
            </div>
            <div className="bot-desc-with-seemore">
                {/* <span className="bot-prop-desc">
                  {(property.overview || "-").slice(0, 120)}...
                </span> */}

               {/* <button
                      className="bot-see-more"
                      onClick={() => {
                        setBotPopupData({
                          
                        });
                        setIsBotPopupOpen(true);
                      }}
                    >
                      Learn More →
                    </button> */}
              </div>
            

          </div>
        </div>
      ))}

      {/* Load More OUTSIDE grey boxes */}
      {messages[i + 1]?.type === "button" &&
        messages[i + 1].contextId === msg.contextId && (
          <div className="load-more-wrapper">
            <button onClick={() => handleLoadMore(msg.contextId)}>
              {messages[i + 1].label}
            </button>
          </div>
      )}
    </div>
  );
}
 else {
                return (
                  <div
                    key={i}
                    className={`message-container ${msg.sender} ${
                      i === 0 && msg.sender === "bot" && !hasUserReplied
                        ? "first-bot"
                        : ""
                    }`}
                  >
                    <div
                      className={`message ${msg.sender}`}
                      dangerouslySetInnerHTML={{ __html: msg.text }}
                    />
                  </div>
                );
              }
            })}
          
            {loading && <div className="message bot">Typing...</div>}
            <div ref={bottomRef} />
          </div>
          
          <div className="news-btn" onClick={() => setShowNews(true)}>
            📰 News
          </div>

          <div className="feedback-btn" onClick={() => setShowFeedback(true)}>
            📝 Feedback
          </div>

          <div className="chat-input-wrapper">
            <div className="chat-input-box">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder="Ask for properties..."
              />
              <button className="send-btn" onClick={sendMessage}>
                <span className="arrow-up">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="arrow-icon"
                    viewBox="0 0 24 24"
                    fill="white"
                    width="18"
                    height="18"
                  >
                    <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.59 5.58L20 12l-8-8-8 8z" />
                  </svg>
                </span>
              </button>
            </div>
            <div className="disclaimer-text">
              RealEstate Chat Assistance can make mistakes. Check our{" "}
              <span className="tnc-link" onClick={() => setShowTerms(true)}>
                Terms & Conditions.
              </span>
            </div>
          </div>
        </div>
      </div>

{isBotPopupOpen && (
  <div className="bot-popup-Enquire property-modal-overlay">
    <div className="bot-popup-container">
      <button
        className="bot-popup-close-btn"
        onClick={() => setIsBotPopupOpen(false)}
      >
        ✕
      </button>
      <div className="popupDetailsbanner">
          <h2>Bhavisha Gardeniaa Phase 4</h2>
                <div className="topImageam">
                  <figure>
                    <img
                      src="https://www.tarc.in/images/blog4.jpg"
                      alt="Property"
                      className="bot-popup-image"
                    />
                    <figcaption>Elevation </figcaption>
                  </figure>
                
                  <figure>
                    <img
                      src="https://www.genesisstudios.com/wp-content/uploads/2023/01/921499-Fairbrook-Communities-Flamingo-Bay-1.jpg"
                      alt="Property"
                      className="bot-popup-image"
                    />
                      <figcaption>Floor plan </figcaption>
                  </figure>
                </div>
                  
                  <h3 className="bot-popup-heading">Property amenities</h3>

                <ul class="bot-popup-amenities">
                      <li><span className="AmnitiesIcon"><img src={badIcon} alt="Gymnasium" /></span>Gymnasium</li>
                      <li><span className="AmnitiesIcon"><img src={areaIcon} alt="Swimming Pool" /></span>Swimming Pool</li>
                      <li><span className="AmnitiesIcon"><img src={badminton} alt="Kids Play Area" /></span>Kids Play Area</li>
                      <li><span className="AmnitiesIcon"><img src={bathtub} alt="Badminton Court(s)" /></span>Badminton Court(s)</li>
                      <li><span className="AmnitiesIcon"><img src={gymnasium} alt="Gymnasium" /></span>Gymnasium</li>
                      <li><span className="AmnitiesIcon"><img src={swimming} alt="Swimming Pool" /></span> Swimming Pool</li>
                      <li><span className="AmnitiesIcon"><img src={badIcon} alt="Kids play area" /></span>Kids Play Area</li>
                      <li><span className="AmnitiesIcon"><img src={badIcon} alt="Badminton Court(s)" /></span>Badminton Court(s)</li>
                  </ul>

                  <button className="EnquiryNow"> Enquiry Now</button>
        </div>
    </div>
  </div>
)}

      {/* 🪟 Property Details Modal (clean layout) */}
{showDetails && propertyDetails && (
  <div className="property-modal-overlay" onClick={() => setShowDetails(false)}>
    <div className="property-modal" onClick={(e) => e.stopPropagation()}>
      {/* close */}
      <button className="modal-close" onClick={() => setShowDetails(false)}>✕</button>

      {/* header image */}
      {propertyDetails.image_url ? (
        <img
          src={propertyDetails.image_url}
          alt={propertyDetails.property_name || "Property image"}
          className="modal-image"
        />
      ) : (
        <div className="modal-image placeholder-image">No Image</div>
      )}

      <div className="modal-body">
        {/* title + meta row */}
        <div className="modal-head">
          <h2 className="modal-title">{propertyDetails.property_name || "Property"}</h2>
          <div className="meta-chips">
            {propertyDetails.property_type && <span className="chip">{propertyDetails.property_type}</span>}
            {propertyDetails.amount && <span className="chip">₹ {formatPrice(propertyDetails.amount)}</span>}
            {/* {propertyDetails.features?.rera_approved ? <span className="chip chip-green">RERA</span> : null} */}
            {propertyDetails.units && <span className="chip">{propertyDetails.units} Units</span>}
          </div>
        </div>

        {/* two column info */}
        <div className="modal-grid">
          <div className="info-col">
            <div className="kv">
              <span className="k">Location</span>
              <span className="v">
                {propertyDetails.location || "—"}{propertyDetails.city ? `, ${propertyDetails.city}` : ""}
              </span>
            </div>
            {propertyDetails.developer && (
              <div className="kv">
                <span className="k">Developer</span>
                <span className="v">{propertyDetails.developer}</span>
              </div>
            )}
            <div className="kv">
              <span className="k">Bedrooms</span>
              <span className="v">{propertyDetails.unit_name || propertyDetails.bedrooms || "—"}</span>
            </div>
            <div className="kv">
              <span className="k">Carpet Area</span>
              <span className="v">{propertyDetails.unit_size || "—"}</span>
            </div>
            <div className="kv">
              <span className="k">Price</span>
              <span className="v">
                ₹{formatPrice(propertyDetails.amount)}
              </span>
            </div>
          </div>

          <div className="info-col">
            {propertyDetails.description && (
              <div className="desc">
                {propertyDetails.description}
              </div>
            )}

            {/* amenities */}
            {Array.isArray(propertyDetails.amenities) && propertyDetails.amenities.length > 0 && (
              <div className="amenities">
                <div className="section-title">Amenities</div>
                <ul className="amenity-list">
                  {propertyDetails.amenities.map((a, i) => (
                    <li key={i}>• {a}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* feature bullets */}
        {propertyDetails.features && (
          <div className="features">
            {Object.entries(propertyDetails.features)
              .filter(([_, v]) => !!v)
              .map(([k]) => (
                <span key={k} className="feature-pill">{k.replace(/_/g, " ")}</span>
              ))}
          </div>
        )}

        {/* footer actions */}
        <div className="modal-footer">
          {/* <button
            className="btn btn-primary"
            onClick={() => alert(`Enquiry for ${propertyDetails.property_name || "this property"}`)}
          >
            Enquire Now
          </button> */}
          <button
            className="btn btn-primary"
            onClick={() => {
              setSelectedProperty(propertyDetails);
              setShowEnquiry(true);
            }}
          >
            Enquire Now
          </button>

          <button className="btn btn-ghost" onClick={() => setShowDetails(false)}>Close</button>
        </div>
      </div>
    </div>
  </div>
)}








{/* 📨 Enquiry Modal */}
{showEnquiry && (
  <div className="property-modal-overlay" onClick={() => setShowEnquiry(false)}>
    <div className="property-modal small" onClick={(e) => e.stopPropagation()}>
      <button className="modal-close" onClick={() => setShowEnquiry(false)}>✕</button>
      <h2>Send Enquiry</h2>

      <div className="enquiry-form">
        <input
          type="text"
          placeholder="Your Name"
          value={enquiryData.name}
          onChange={(e) => setEnquiryData({ ...enquiryData, name: e.target.value })}
        />
        {enquiryErrors.name && (
          <div className="error-text">{enquiryErrors.name}</div>
        )}
        <input
          type="email"
          placeholder="Your Email"
          value={enquiryData.email}
          onChange={(e) => setEnquiryData({ ...enquiryData, email: e.target.value })}
        />
        {enquiryErrors.email && (
          <div className="error-text">{enquiryErrors.email}</div>
        )}
        <input
          type="tel"
          placeholder="Your Phone"
          value={enquiryData.phone}
          onChange={(e) => setEnquiryData({ ...enquiryData, phone: e.target.value })}
        />
        {enquiryErrors.phone && (
          <div className="error-text">{enquiryErrors.phone}</div>
        )}
        <textarea
          placeholder="Message (optional)"
          value={enquiryData.message}
          onChange={(e) => setEnquiryData({ ...enquiryData, message: e.target.value })}
        ></textarea>

        <button className="btn btn-primary" onClick={handleSubmitEnquiry}>
          Submit Enquiry
        </button>
      </div>
    </div>
  </div>
)}





{/* ✅ Success Popup */}
{showSuccessPopup && (
  <div className="success-popup-overlay">
    <div className="success-popup">
      <button
        className="success-popup-close"
        onClick={() => setShowSuccessPopup(false)}
      >
        ✕
      </button>
      <div className="success-icon">✅</div>
      <h3>Enquiry Sent Successfully!</h3>
      <p>Our property expert will contact you shortly.</p>
    </div>
  </div>
)}


{/* 📝 Terms & Conditions Popup */}
{showTerms && (
  <div className="property-modal-overlay" onClick={() => setShowTerms(false)}>
    <div
      className="property-modal small"
      onClick={(e) => e.stopPropagation()}
      style={{ maxWidth: "600px", padding: "20px" }}
    >
      <button className="modal-close" onClick={() => setShowTerms(false)}>
        ✕
      </button>

      <h2>Terms & Conditions</h2>

      <div className="tnc-content">
        <p>
          Our RealEstate Chat Assistance provides general property suggestions
          based on available data. The system may occasionally produce incorrect
          or incomplete results.
        </p>

        <ul>
          <li>This tool does not provide legal or financial advice.</li>
          <li>Property availability & price may vary from actual site data.</li>
          <li>Always verify details with our property experts.</li>
          <li>Your chat data may be securely stored for enquiry purposes.</li>
        </ul>

        <p>
          By using this service, you agree that suggestions are provided on a
          best-effort basis and may contain inaccuracies.
        </p>

        <button className="btn btn-primary" onClick={() => setShowTerms(false)}>
          Close
        </button>
      </div>
    </div>
  </div>
)}

{showNews && (
  <div className="news-overlay" onClick={() => setShowNews(false)}>
    <div className="news-drawer" onClick={(e) => e.stopPropagation()}>

      {/* Drag handle */}
      <div className="news-handle" />

      {/* Header */}
      {/* <div className="left-header">
        <img
          src="https://www.addressofchoice.com/aoc_assets_new/images/est-chat.svg"
          alt="Logo"
          className="left-logo"
        />
      </div> */}

      {/* Content */}
      <div className="left-scroll-content">
        <NewsFeed
          onBannerClick={() => {
            setSelectedProperty({
              id: 100,
              property_name: "Danube Breez - Dubai Maritime City",
            });
            setShowEnquiry(true);
            setShowNews(false); // ✅ auto close drawer
          }}
        />
      </div>

      <div className="powered-by-left">
        Powered by
        <img
          src="https://www.addressofchoice.com/aoc_assets_new/images/favicon.png"
          alt="AddressOfChoice"
          height="24"
        />
      </div>

    </div>
  </div>
)}


{showFeedback && (
  <div className="feedback-overlay" onClick={() => setShowFeedback(false)}>
    <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>

      <button className="feedback-close" onClick={() => setShowFeedback(false)}>✕</button>

      <h2 className="feedback-title">Share Your Feedback</h2>

      <div className="feedback-field">
        <label className="feedback-label">
          Mobile Number <span className="required">*</span>
        </label>
        <input
          className="feedback-input"
          type="text"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          placeholder="Enter your mobile number"
        />
        {errors.mobile && <div className="error-text">{errors.mobile}</div>}
      </div>

      <div className="feedback-field">
        <label className="feedback-label margin-top">
          Your Feedback <span className="required">*</span>
        </label>
        <textarea
          className="feedback-textarea"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Tell us about your experience..."
        />
        {errors.feedback && <div className="error-text">{errors.feedback}</div>}
      </div>

      <div className="feedback-actions margin-top">
        <button
  className="feedback-submit-btn"
  onClick={handleSubmitFeedback}
>
  Submit Feedback
</button>

      </div>

    </div>
  </div>
)}





  {feedbackSuccess && (
  <div className="success-popup-overlay">
    <div className="success-popup">
      <button className="success-popup-close" onClick={() => setFeedbackSuccess(false)}>
        ✕
      </button>
      <div className="success-icon">🎉</div>
      <h3>Thank you for your feedback!</h3>
      <p>Your feedback has been submitted.</p>
    </div>
  </div>
)}




    </div>
  );
  
}

export default ChatBot;
